let timer, flag

/**
 * 截流：在一定的时间内，只能触发一次
 * @param {Function} func 要执行的函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 */
export default function throttle(func, wait = 500, immediate = true) {
  if (immediate) {
    if (!flag) {
      flag = true
      typeof func === 'function' && func()
      timer = setTimeout(() => {
        flag = false
      }, wait)
    }
  } else {
    if (!flag) {
      flag = true
      timer = setTimeout(() => {
        flag = false
        typeof func === 'function' && func()
      }, wait)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/utils/throttle.js